import request from '../../../shared/request'

export function getJobFinancialSummary(job_id) {
  return request(`/job/${job_id}/financial_summary`)
}

export function updateJobFinancialSummary(payload) {
  return request(`/job/${payload.job_id}/financial_summary`, {
    method: 'PUT',
    body: payload,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}



// WEBPACK FOOTER //
// ./src/redux/api/job/financialSummary.js